<template>
    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Add a User</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4">

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Name
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" type="text" v-model="name">
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Email
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" type="email" v-model="email">
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Permission
                    </label>
                    <label class="dropdown_wrap">
                        <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="role">
                            <option value="videographer">Videographer</option>
                            <option value="media_purchaser">Media Purchaser</option>
                            <option value="media_producer">Media Producer</option>
                            <option value="administrator">Administrator</option>
                            <option value="superadministrator">Super Administrator</option>
                        </select>
                    </label>
                </div>

                <div class="mb-4" v-if="role == 'media_purchaser' || role == 'media_producer'">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Network
                    </label>
                    <label class="dropdown_wrap">
                        <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="network">
                            <option v-for="network in networks" :value="network['id']">{{ network.name }}</option>
                        </select>
                    </label>
                </div>

                <div class="mb-4" v-if="role !== 'media_purchaser' && role !== 'media_producer'">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Percentage
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="number" v-model="percentage">
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Password
                    </label>
                    <div class="flex">
                        <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="password">
                        <button class="px-3 py-1 bg-blue-700 rounded text-white ml-4 text-sm" v-on:click="makePassword">
                            <i class="fa fa-sync"></i>
                        </button>
                    </div>
                </div>

            </div>

             <!-- footer -->
            <div class="mt-10 clearfix">
                <!-- @click="addAnnouncement()" -->
                <button v-on:click="displayModal = false" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                    Cancel
                </button>
                <button v-on:click="addUser" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                    Add User
                </button>
            </div>

        </div>
    </Modal>

</template>

<script>
    import { EventBus } from '@/utils/events'
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex'
    import Modal from '@/components/Modal'

    export default {
        data() {
            return {
                displayModal: false,
                name: null,
                email: null,
                role: 'videographer',
                network: null,
                percentage: null,
                password: null,
                networks: {},
            }
        },

        components: {
            Modal
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('admin-add-user-open-modal', this.open);
            }.bind(this));

            this.makePassword();
        },

        destroyed() {
            EventBus.$off('admin-add-user-open-modal', this.open);
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            open() {
                this.displayModal = true
            },

            addUser() {
                var _this = this;

                var data = {
                    name: this.name,
                    email: this.email,
                    role: this.role,
                    network: this.network,
                    percentage: this.percentage,
                    password: this.password,
                }

                this.$http.post(Config.apiPath + "/api/v2/admin/users/new", data, this.getAuthorizationHeader()).then((response) => {
                    console.log(response.status)
                    if(response.status == 200) {

                        EventBus.$emit('admin-add-user-refresh-data');
                        _this.displayModal = false

                        this.name = null
                        this.email = null
                        this.role = 'videographer'
                        this.network = null
                        this.percentage = null
                        this.password = null

                    }
                });

            },

            makePassword() {
                var text = "";
                var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

                for (var i = 0; i < 20; i++)
                    text += possible.charAt(Math.floor(Math.random() * possible.length));

                this.password = text;
            },

            getNetworks() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/networks", this.getAuthorizationHeader()).then((response) => {
                    _this.networks = response.data
                });
            },

        },

        watch: {

            role: function(data) {
                if(data == 'media_producer' || data == 'media_purchaser') {
                    this.getNetworks();
                }
            }

        }
        
    }
</script>
